import {
  createContext,
  createSignal,
  ParentComponent,
  useContext,
  Accessor,
} from "solid-js";

interface AppRefreshContextType {
  refreshKey: Accessor<number>;
  refreshApp: () => void;
}

const AppRefreshContext = createContext<AppRefreshContextType>();

export const AppRefreshProvider: ParentComponent = (props) => {
  const [refreshKey, setRefreshKey] = createSignal(0);

  const refreshApp = () => {
    console.log("Refreshing app...");
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <AppRefreshContext.Provider value={{ refreshKey, refreshApp }}>
      {props.children}
    </AppRefreshContext.Provider>
  );
};

export const useAppRefresh = () => {
  const context = useContext(AppRefreshContext);

  if (!context) {
    throw new Error("useAppRefresh must be used within AppRefreshProvider");
  }

  return context;
};
